import type { ItemPropTypes } from '@george-labs.com/design-system/types/components/Dropdown';
import { Select, type WrapperFC } from '@george-labs.com/design-system';

import { useField } from '@luna/form2';

import { CurrencySelect } from './CurrencySelect';

interface Props {
    'data-cy': string;
    name: string;
    currencies: string[];
    disabled?: boolean;
}

export const CurrenciesSelectFormField: WrapperFC<Props> = ({
    'data-cy': dataCy,
    name,
    disabled = false,
    currencies,
}) => {
    const [{ value }, , { setValue }] = useField(name);

    const handleSelect = (selected: ItemPropTypes | ItemPropTypes[] | null) => {
        if (selected && !Array.isArray(selected)) {
            setValue(selected.value);
        }
    };

    return (
        <CurrencySelect
            data-cy={dataCy}
            items={currencies}
            onSelect={handleSelect}
            value={value}
            disabled={disabled}
        />
    );
};

CurrenciesSelectFormField.wrapsComponent = Select;
